import React from 'react';

import { Grid, makeStyles } from '@material-ui/core';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { Typography } from '../../../../ui';
import flipDishLogo from '../../../assets/images/flipDishLogo.svg';
import { cookieConsent } from '../../../cookieconsent';
import { basketSelectors, cookieSelectors } from '../../../selectors';

const useStyles = makeStyles({
  link: {
    color: 'inherit',
  },
});
const PrivacyTermsComponent = (props: MappedState) => {
  const classes = useStyles(props);
  const showCookieSettings = props.hasGdprCookieFeatureFlag;

  const handleShowSettings = () => {
    cookieConsent.edit();
  };

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      style={{ fontSize: '12px', color: '#888888', paddingBottom: '12px' }}
    >
      <img
        src={flipDishLogo}
        alt="Flipdish logo"
        style={{ width: '92px', height: '25px' }}
      />
      <Typography variant="caption">
        <div style={{ fontSize: '10px', paddingTop: '4px' }}>
          <Translate id="secured_with_Flipdish" />
        </div>
      </Typography>
      <Grid style={{ paddingTop: '12px' }}>
        {/*// New requirements! hide link (don't remove temporary)*/}
        {/*<Link className={classes.link} target="_blank" to={props.termsLink}>*/}
        {/*  <Translate id="Terms" />*/}
        {/*</Link>*/}
        {/*<span> | </span>*/}
        {/*<Link className={classes.link} target="_blank" to={props.privacyLink}>*/}
        {/*  <Translate id="Privacy" />*/}
        {/*</Link>*/}

        {/*<span> | </span>*/}
        {/*<Link className={classes.link} target="_blank" to={props.cookiePolicyLink}>*/}
        {/*  <Translate id="Cookie_policy" />*/}
        {/*</Link>*/}

        {showCookieSettings && (
          <>
            {/*<span> | </span>*/}
            <Link
              className={classes.link}
              tabIndex={0}
              onClick={handleShowSettings}
              to=""
            >
              <span style={{ cursor: 'pointer' }}>
                <Translate id="cookie_settings" />
              </span>
            </Link>
          </>
        )}
      </Grid>
    </Grid>
  );
};

type MappedState = {
  termsLink: string;
  privacyLink: string;
  cookiePolicyLink: string;
  hasGdprCookieFeatureFlag: boolean;
};
const mapStateToProps = (state): MappedState => {
  const config = basketSelectors.getAppConfig(state);

  return {
    termsLink: config?.TermsAndConditionsUrl,
    privacyLink: config?.PrivacyPolicyUrl,
    cookiePolicyLink: config?.CookiePolicyUrl,
    hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
  };
};

export const PrivacyTerms = connect(mapStateToProps)(PrivacyTermsComponent);
